module.exports = __webpack_public_path__ + "static/media/LogoIdentity.5f1da6f0.svg";